module.exports = __webpack_public_path__ + "img/new_message_flatline.24d43ab0.svg";